import Vue from "vue";
import Vuex from "vuex";

import Account from "./account.module";
import Lenders from "./lenders.module";
import Basket from "./shoppingBasket.module"
import Watchers from "./mortgageWatchers.module"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Account,
    Lenders,
    Basket,
    Watchers
  }
});
